import React from "react";
import NumberFormat from "react-number-format";
import { WithTooltip } from "../../../utils/glossaryHelper/GlossaryWithTooltip";
import { checkPermission } from "../../../config/utils";

export const BuildingStatistics = ({
    sidePanelValues,
    disableButton,
    activeSection,
    handleBuildingView,
    handleRecommentationView,
    handleAssetsView,
    handleRegionView,
    handleSiteView,
    handleView,
    handleAdditionsView,
    handleCapitalRequestView,
    capitalRequestLabel = "Capital Request",
    handleFloorsView,
    isAssetDashboardView = false,
    isMobileAssetDashboardView = false,
    handleClientView
}) => {
    // The Mobile Asset Dashboard counts mobile assets, so the tile says so
    const assetsLabel = isMobileAssetDashboardView ? "Mobile Assets" : "Assets";
    const assetSidePanelValues = isAssetDashboardView && sidePanelValues?.is_asset_dashboard_view ? sidePanelValues : null;
    const dashboardSidePanelValues = !isAssetDashboardView && !sidePanelValues?.is_asset_dashboard_view ? sidePanelValues : null;

    return isAssetDashboardView ? (
        <>
            <div className="list-ara">
                <div className="lst">
                    <div className="sm-hed">FCA Cost</div>

                    <div className="val-hed notranslate">
                        <span>
                            {assetSidePanelValues ? (
                                <NumberFormat
                                    value={parseFloat((assetSidePanelValues.total_csp ? assetSidePanelValues.total_csp : 1) / 1000000).toFixed(2)}
                                    suffix={"M"}
                                    thousandSeparator={true}
                                    displayType={"text"}
                                    prefix={"$ "}
                                />
                            ) : (
                                0
                            )}
                        </span>
                    </div>
                </div>
                <div className="lst">
                    <div className="sm-hed">
                        Total <WithTooltip>SF</WithTooltip>
                    </div>
                    <div className="val-hed">
                        <span>
                            {assetSidePanelValues ? (
                                <NumberFormat
                                    value={assetSidePanelValues.total_sf ? assetSidePanelValues.total_sf : 0}
                                    thousandSeparator={true}
                                    displayType={"text"}
                                    decimalScale={0}
                                />
                            ) : (
                                0
                            )}
                        </span>
                    </div>
                </div>

                <div className="lst">
                    <div className="sm-hed">
                        Total <WithTooltip>CRV</WithTooltip>
                    </div>
                    <div className="val-hed notranslate">
                        <span>
                            {assetSidePanelValues ? (
                                <NumberFormat
                                    value={parseFloat(
                                        (assetSidePanelValues.total_replacement_cost ? assetSidePanelValues.total_replacement_cost : 1) / 1000000
                                    ).toFixed(2)}
                                    suffix={"M"}
                                    thousandSeparator={true}
                                    displayType={"text"}
                                    prefix={"$ "}
                                />
                            ) : (
                                0
                            )}
                        </span>
                    </div>
                </div>
                <div
                    className={`${
                        !disableButton && assetSidePanelValues?.assets && checkPermission("forms", "assets", "view")
                            ? activeSection === "asset"
                                ? "lst cursor-pointer btn-clickable active-sectn"
                                : "lst cursor-pointer btn-clickable"
                            : "lst"
                    }`}
                    data-delay-show="500"
                    data-tip={
                        !disableButton && assetSidePanelValues?.assets && checkPermission("forms", "assets", "view")
                            ? `Click To View ${assetsLabel}`
                            : ""
                    }
                    data-effect="solid"
                    data-for="filter-icons"
                    data-place="right"
                    data-background-color="#007bff"
                    onClick={
                        !disableButton && assetSidePanelValues?.assets && checkPermission("forms", "assets", "view") ? () => handleAssetsView() : null
                    }
                >
                    <div>
                        <div className="sm-hed">{assetsLabel}</div>
                        <div className="val-hed">
                            <span>
                                {assetSidePanelValues ? (
                                    <NumberFormat
                                        value={assetSidePanelValues?.assets ? assetSidePanelValues?.assets : 0}
                                        thousandSeparator={true}
                                        displayType={"text"}
                                    />
                                ) : (
                                    0
                                )}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="list-ara">
                {assetSidePanelValues && assetSidePanelValues.hasOwnProperty("capital_request") && (
                    <div
                        className={`${
                            !disableButton && assetSidePanelValues.capital_request !== 0
                                ? activeSection === "capital_request"
                                    ? "lst cursor-pointer btn-clickable d-flex active-sectn"
                                    : "lst cursor-pointer btn-clickable d-flex"
                                : "lst d-flex"
                        }`}
                        data-delay-show="500"
                        data-tip={!disableButton && assetSidePanelValues.capital_request !== 0 ? `Click To View ${capitalRequestLabel}` : ""}
                        data-effect="solid"
                        data-for="filter-icons"
                        data-place="bottom"
                        data-background-color="#007bff"
                        onClick={!disableButton && assetSidePanelValues.capital_request !== 0 ? () => handleCapitalRequestView() : null}
                    >
                        <div className="cursor-hand">
                            <div className="sm-hed mr-2 flex-grow-1">{capitalRequestLabel}</div>
                            <div className="val-hed">{assetSidePanelValues ? assetSidePanelValues.capital_request : 0}</div>
                        </div>
                    </div>
                )}
                <div
                    className={`${
                        !disableButton && assetSidePanelValues?.client_id && checkPermission("forms", "clients", "view")
                            ? activeSection === "clients"
                                ? "lst cursor-pointer btn-clickable d-flex active-sectn"
                                : "lst cursor-pointer btn-clickable d-flex"
                            : "lst d-flex"
                    }`}
                    data-delay-show="500"
                    data-tip={
                        !disableButton && assetSidePanelValues?.client_id && checkPermission("forms", "clients", "view")
                            ? `Click To View Client Details`
                            : ""
                    }
                    data-effect="solid"
                    data-for="filter-icons"
                    data-place="bottom"
                    data-background-color="#007bff"
                    onClick={
                        !disableButton && assetSidePanelValues?.client_id && checkPermission("forms", "clients", "view") ? handleClientView : null
                    }
                >
                    <div className="cursor-hand">
                        <div className="sm-hed mr-2 flex-grow-1">Client</div>
                        <div className="val-hed">{assetSidePanelValues ? 1 : 0}</div>
                    </div>
                </div>
                <div
                    className={`${
                        !disableButton && assetSidePanelValues?.regions !== 0 && checkPermission("forms", "regions", "view")
                            ? activeSection === "region"
                                ? "lst cursor-pointer btn-clickable d-flex active-sectn"
                                : "lst cursor-pointer btn-clickable d-flex"
                            : "lst d-flex"
                    }`}
                    data-delay-show="500"
                    data-tip={`Click To View Regions `}
                    data-effect="solid"
                    data-for="filter-icons"
                    data-place="right"
                    data-background-color="#007bff"
                    onClick={
                        !disableButton && assetSidePanelValues?.regions !== 0 && checkPermission("forms", "regions", "view")
                            ? () => handleRegionView("client")
                            : null
                    }
                >
                    <div>
                        <div
                            className="sm-hed mr-2 flex-grow-1"
                            onClick={
                                !disableButton && assetSidePanelValues?.regions !== 0 && checkPermission("forms", "regions", "view")
                                    ? () => assetSidePanelValues && handleRegionView("client")
                                    : null
                            }
                        >
                            Regions
                        </div>
                        <div className="val-hed">{assetSidePanelValues ? assetSidePanelValues.regions : 0}</div>
                    </div>
                </div>
                <div
                    className={`${
                        !disableButton && assetSidePanelValues?.sites !== 0 && checkPermission("forms", "sites", "view")
                            ? activeSection === "site"
                                ? "lst cursor-pointer btn-clickable d-flex active-sectn"
                                : "lst cursor-pointer btn-clickable d-flex"
                            : "lst d-flex"
                    }`}
                    data-delay-show="500"
                    data-tip={
                        !disableButton && assetSidePanelValues?.sites !== 0 && checkPermission("forms", "sites", "view") ? `Click To View Sites ` : ""
                    }
                    data-effect="solid"
                    data-for="filter-icons"
                    data-place="bottom"
                    data-background-color="#007bff"
                    onClick={
                        !disableButton && assetSidePanelValues?.sites !== 0 && checkPermission("forms", "sites", "view")
                            ? () => handleSiteView("client")
                            : null
                    }
                >
                    <div>
                        <div className="sm-hed mr-2 flex-grow-1">Sites</div>
                        <div className="val-hed">{assetSidePanelValues ? assetSidePanelValues.sites : 0}</div>
                    </div>
                </div>
                <div
                    className={`${
                        !disableButton && assetSidePanelValues?.buildings !== 0 && checkPermission("forms", "buildings", "view")
                            ? activeSection === "building"
                                ? "lst cursor-pointer btn-clickable d-flex active-sectn"
                                : "lst cursor-pointer btn-clickable d-flex"
                            : "lst d-flex"
                    }`}
                    data-delay-show="500"
                    data-tip={
                        !disableButton && assetSidePanelValues?.buildings !== 0 && checkPermission("forms", "buildings", "view")
                            ? `Click To View Buildings `
                            : ""
                    }
                    data-effect="solid"
                    data-for="filter-icons"
                    data-place="right"
                    data-background-color="#007bff"
                    onClick={
                        !disableButton && assetSidePanelValues?.buildings !== 0 && checkPermission("forms", "buildings", "view")
                            ? () => handleBuildingView("client")
                            : null
                    }
                >
                    <div>
                        <div className="sm-hed mr-2 flex-grow-1" onClick={() => handleBuildingView("client")}>
                            Bulidings
                        </div>
                        <div className="val-hed">{assetSidePanelValues ? assetSidePanelValues.buildings : 0}</div>
                    </div>
                </div>
            </div>
        </>
    ) : (
        <>
            <div className="list-ara">
                <div className="lst">
                    <div className="sm-hed">
                        Total <WithTooltip>CSP</WithTooltip>
                    </div>

                    <div className="val-hed notranslate">
                        <span>
                            {dashboardSidePanelValues ? (
                                <NumberFormat
                                    value={parseFloat(
                                        (dashboardSidePanelValues.total_csp ? dashboardSidePanelValues.total_csp : 1) / 1000000
                                    ).toFixed(2)}
                                    suffix={"M"}
                                    thousandSeparator={true}
                                    displayType={"text"}
                                    prefix={"$ "}
                                />
                            ) : (
                                0
                            )}
                        </span>
                    </div>
                </div>
                <div className="lst">
                    <div className="sm-hed">
                        Total <WithTooltip>SF</WithTooltip>
                    </div>
                    <div className="val-hed">
                        <span>
                            {dashboardSidePanelValues ? (
                                <NumberFormat
                                    value={dashboardSidePanelValues.total_sf ? dashboardSidePanelValues.total_sf : 0}
                                    thousandSeparator={true}
                                    displayType={"text"}
                                    decimalScale={0}
                                />
                            ) : (
                                0
                            )}
                        </span>
                    </div>
                </div>

                <div className="lst">
                    <div className="sm-hed">
                        Total <WithTooltip>CRV</WithTooltip>
                    </div>
                    <div className="val-hed notranslate">
                        <span>
                            {dashboardSidePanelValues ? (
                                <NumberFormat
                                    value={parseFloat(
                                        (dashboardSidePanelValues.total_replacement_cost ? dashboardSidePanelValues.total_replacement_cost : 1) /
                                            1000000
                                    ).toFixed(2)}
                                    suffix={"M"}
                                    thousandSeparator={true}
                                    displayType={"text"}
                                    prefix={"$ "}
                                />
                            ) : (
                                0
                            )}
                        </span>
                    </div>
                </div>
                <div
                    className={`${
                        !disableButton && dashboardSidePanelValues?.recommendations
                            ? activeSection === "recommendation"
                                ? "lst cursor-pointer btn-clickable active-sectn"
                                : "lst cursor-pointer btn-clickable"
                            : "lst"
                    }`}
                    data-delay-show="500"
                    data-tip={`Click To View Recommendations`}
                    data-effect="solid"
                    data-for="filter-icons"
                    data-place="right"
                    data-background-color="#007bff"
                    onClick={!disableButton && dashboardSidePanelValues?.recommendations ? () => handleRecommentationView() : null}
                >
                    <div>
                        <div className="sm-hed">Recommendations</div>
                        <div className="val-hed">
                            <span>
                                {dashboardSidePanelValues ? (
                                    <NumberFormat
                                        value={dashboardSidePanelValues.recommendations ? dashboardSidePanelValues.recommendations : 0}
                                        thousandSeparator={true}
                                        displayType={"text"}
                                    />
                                ) : (
                                    0
                                )}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="list-ara">
                {dashboardSidePanelValues && dashboardSidePanelValues.hasOwnProperty("capital_request") && (
                    <div
                        className={`${
                            !disableButton && dashboardSidePanelValues.capital_request !== 0
                                ? activeSection === "capital_request"
                                    ? "lst cursor-pointer btn-clickable d-flex active-sectn"
                                    : "lst cursor-pointer btn-clickable d-flex"
                                : "lst d-flex"
                        }`}
                        data-delay-show="500"
                        data-tip={!disableButton && dashboardSidePanelValues.capital_request !== 0 ? `Click To View ${capitalRequestLabel}` : ""}
                        data-effect="solid"
                        data-for="filter-icons"
                        data-place="bottom"
                        data-background-color="#007bff"
                        onClick={!disableButton && dashboardSidePanelValues.capital_request !== 0 ? () => handleCapitalRequestView() : null}
                    >
                        <div className="cursor-hand">
                            <div className="sm-hed mr-2 flex-grow-1">{capitalRequestLabel}</div>
                            <div className="val-hed">{dashboardSidePanelValues ? dashboardSidePanelValues.capital_request : 0}</div>
                        </div>
                    </div>
                )}
                <div
                    className={`${
                        !disableButton && dashboardSidePanelValues?.projects
                            ? activeSection === "project"
                                ? "lst cursor-pointer btn-clickable d-flex active-sectn"
                                : "lst cursor-pointer btn-clickable d-flex"
                            : "lst d-flex"
                    }`}
                    data-delay-show="500"
                    data-tip={!disableButton && dashboardSidePanelValues?.projects !== 0 ? `Click To View Projects` : ""}
                    data-effect="solid"
                    data-for="filter-icons"
                    data-place="bottom"
                    data-background-color="#007bff"
                    onClick={!disableButton && dashboardSidePanelValues?.projects !== 0 ? () => handleView("projects", "Projects") : null}
                >
                    <div className="cursor-hand">
                        <div className="sm-hed mr-2 flex-grow-1">FCA Projects</div>
                        <div className="val-hed">{dashboardSidePanelValues ? dashboardSidePanelValues?.projects : 0}</div>
                    </div>
                </div>
                <div
                    className={`${
                        !disableButton && dashboardSidePanelValues?.regions !== 0
                            ? activeSection === "region"
                                ? "lst cursor-pointer btn-clickable d-flex active-sectn"
                                : "lst cursor-pointer btn-clickable d-flex"
                            : "lst d-flex"
                    }`}
                    data-delay-show="500"
                    data-tip={`Click To View Regions `}
                    data-effect="solid"
                    data-for="filter-icons"
                    data-place="right"
                    data-background-color="#007bff"
                    onClick={!disableButton && dashboardSidePanelValues?.regions !== 0 ? () => handleRegionView() : null}
                >
                    <div>
                        <div
                            className="sm-hed mr-2 flex-grow-1"
                            onClick={() =>
                                dashboardSidePanelValues && handleView("regions", "Regions", { region_ids: dashboardSidePanelValues.region_ids })
                            }
                        >
                            Regions
                        </div>
                        <div className="val-hed">{dashboardSidePanelValues ? dashboardSidePanelValues.regions : 0}</div>
                    </div>
                </div>
                <div
                    className={`${
                        !disableButton && dashboardSidePanelValues?.sites !== 0
                            ? activeSection === "site"
                                ? "lst cursor-pointer btn-clickable d-flex active-sectn"
                                : "lst cursor-pointer btn-clickable d-flex"
                            : "lst d-flex"
                    }`}
                    data-delay-show="500"
                    data-tip={`Click To View Sites `}
                    data-effect="solid"
                    data-for="filter-icons"
                    data-place="bottom"
                    data-background-color="#007bff"
                    onClick={!disableButton && dashboardSidePanelValues?.sites !== 0 ? () => handleSiteView() : null}
                >
                    <div>
                        <div className="sm-hed mr-2 flex-grow-1">Sites</div>
                        <div className="val-hed">{dashboardSidePanelValues ? dashboardSidePanelValues.sites : 0}</div>
                    </div>
                </div>
                <div
                    className={`${
                        !disableButton && dashboardSidePanelValues?.buildings !== 0
                            ? activeSection === "building"
                                ? "lst cursor-pointer btn-clickable d-flex active-sectn"
                                : "lst cursor-pointer btn-clickable d-flex"
                            : "lst d-flex"
                    }`}
                    data-delay-show="500"
                    data-tip={`Click To View Buildings `}
                    data-effect="solid"
                    data-for="filter-icons"
                    data-place="right"
                    data-background-color="#007bff"
                    onClick={!disableButton && dashboardSidePanelValues?.buildings !== 0 ? () => handleBuildingView() : null}
                >
                    <div>
                        <div className="sm-hed mr-2 flex-grow-1" onClick={() => handleBuildingView()}>
                            Bulidings
                        </div>
                        <div className="val-hed">{dashboardSidePanelValues ? dashboardSidePanelValues.buildings : 0}</div>
                    </div>
                </div>
                <div
                    className={`${
                        !disableButton && dashboardSidePanelValues?.additions
                            ? activeSection === "additions"
                                ? "lst cursor-pointer btn-clickable d-flex active-sectn"
                                : "lst cursor-pointer btn-clickable d-flex "
                            : "lst d-flex"
                    }`}
                    data-delay-show="500"
                    data-tip={!disableButton && dashboardSidePanelValues?.additions !== 0 ? `Click To View Additions` : ""}
                    data-effect="solid"
                    data-for="filter-icons"
                    data-place="bottom"
                    data-background-color="#007bff"
                    onClick={!disableButton && dashboardSidePanelValues?.additions !== 0 ? () => handleAdditionsView() : null}
                >
                    <div className="cursor-hand">
                        <div className="sm-hed mr-2 flex-grow-1">Additions</div>
                        <div className="val-hed">{dashboardSidePanelValues ? dashboardSidePanelValues.additions : 0}</div>
                    </div>
                </div>
                <div
                    className={`${
                        !disableButton && dashboardSidePanelValues?.floors
                            ? activeSection === "floors"
                                ? "lst cursor-pointer btn-clickable d-flex active-sectn"
                                : "lst cursor-pointer btn-clickable d-flex "
                            : "lst d-flex"
                    }`}
                    data-delay-show="500"
                    data-tip={!disableButton && dashboardSidePanelValues?.floors !== 0 ? `Click To View Floors` : ""}
                    data-effect="solid"
                    data-for="filter-icons"
                    data-place="bottom"
                    data-background-color="#007bff"
                    onClick={!disableButton && dashboardSidePanelValues?.floors !== 0 ? () => handleFloorsView() : null}
                >
                    <div className="cursor-hand">
                        <div className="sm-hed mr-2 flex-grow-1">Floors</div>
                        <div className="val-hed">{dashboardSidePanelValues ? dashboardSidePanelValues.floors : 0}</div>
                    </div>
                </div>
            </div>
        </>
    );
};
